import { toastr } from 'react-redux-toastr';
import { get, getOr, each } from 'lodash/fp';

const forEach = each.convert({ cap: false });

export default response => {
  const formErrors = get('error', response);
  if (formErrors) {
    const interval = 2000;
    forEach(({ message }, i) => {
      const timeOut = i * interval + 5000;
      toastr.error('Field Error', message, { timeOut });
    }, formErrors);
  } else {
    toastr.error('Error', getOr('Server error', 'message', response));
  }
};
